import {
  CANONICAL_PORTAL_ORIGIN,
  isLegacyPortalHost,
  legacyPortalRedirectUrl,
} from '@djgg/core';

export {
  CANONICAL_PORTAL_ORIGIN,
  LEGACY_PORTAL_HOSTS,
  isLegacyPortalHost,
  legacyPortalRedirectUrl,
} from '@djgg/core';

export interface PortalLocationLike {
  hostname: string;
  origin: string;
  pathname: string;
  search: string;
  hash: string;
  replace(url: string): void;
}

/** Use the branded origin for public links while preserving local preview URLs. */
export function publicPortalOrigin(location: Pick<PortalLocationLike, 'hostname' | 'origin'>): string {
  return location.hostname === 'djgg.jachai.dev' || isLegacyPortalHost(location.hostname)
    ? CANONICAL_PORTAL_ORIGIN
    : location.origin;
}

/** Redirect a browser that opened a legacy Firebase Hosting URL. */
export function redirectLegacyPortalHost(
  location: PortalLocationLike | undefined = typeof globalThis.location === 'undefined'
    ? undefined
    : globalThis.location,
): boolean {
  if (!location) return false;
  const destination = legacyPortalRedirectUrl(
    location.hostname,
    `${location.pathname}${location.search}${location.hash}`,
  );
  if (!destination) return false;
  location.replace(destination);
  return true;
}
